import { getAnalytics, logEvent as logEventFirebase } from "firebase/analytics";
import { firebaseApp } from "../store/LoggerContext";

let reported = false;

// A browser that lacks `script.noModule` ignored the es2015 module bundle and
// loaded the @vitejs/plugin-legacy es5 + polyfills nomodule bundle instead —
// exactly the population #643 measures for the keep/remove decision. Fire one
// Firebase `legacy_browser` event per such session (anonymous OR signed-in) so
// legacy-bundle uptake is countable in GA4. Modern browsers no-op. Signed-in
// sessions ALSO land in the internal log store via LoggerContext (see the
// userProfile-gated effect there) so the count is queryable without GA4 creds.
// Fires at most once per page load; best-effort — never blocks app startup.
export const reportLegacyBrowser = (): void => {
  if (reported) {
    return;
  }
  reported = true;

  if (typeof document === "undefined") {
    return;
  }
  if ("noModule" in document.createElement("script")) {
    return;
  }

  try {
    logEventFirebase(getAnalytics(firebaseApp), "legacy_browser", {
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    });
  } catch (e) {
    // Analytics is best-effort telemetry; a reporting failure must never
    // break startup for the very old devices this is trying to measure.
  }
};
